module.exports = __webpack_public_path__ + "img/luxura_jewel-open.9dff39de.svg";